export default "__VITE_ASSET__CYtFeXSB__"